'use strict';

import * as angular from 'angular'; 

var monitoringSynchronizationTpl = require('../monitoring/pages/synchronization/synchronization.html');
var monitoringEventTpl = require('../monitoring/pages/event/event.html');
var analysisVuTpl = require('../analysis/vu/vu.html');
var analysisCoverageMapTpl = require('../analysis/coverage-map/coverage-map.html');
var analysisChartTpl = require('../analysis/chart/chart.html');
var analysisBaseTpl = require('../analysis/base/base.html');
var analysisTripOverviewTpl = require('../analysis/overview/trip-overview.html');
var trainScheduleTrainScheduleTpl = require('../train-schedule/train-schedule.html');
var slaTrendAnalysisTrendTpl = require('../sla-trend-analysis/trend.html');
var simOverviewSimOverviewTpl = require('../sim-overview/sim-overview.html');
var dashboardContentStatisticsReportTpl = require('../dashboard/portal/content-statistics-report.html');
var baseErrorTpl = require('../base/error.html');
var simOverviewControllerResolve = require('../sim-overview/simOverviewController.resolve');
var tripTrendControllerResolve = require('../sla-trend-analysis/tripTrendController.resolve');
var tripOverviewControllerResolve = require('../analysis/overview/tripOverviewController.resolve');
var baseAnalysisControllerPeriodResolve = require('../analysis/base/baseAnalysisController.period.resolve');
var baseAnalysisControllerTripResolve = require('../analysis/base/baseAnalysisController.trip.resolve');

import uiRouter from '@uirouter/angularjs';
import "@uirouter/angularjs/release/stateEvents";

var app = angular.module('noc.routes', [ uiRouter, 'ui.router.upgrade', 'ui.router.state.events', 'oc.lazyLoad']);

app.config(["$urlRouterProvider", "$stateProvider", "$ocLazyLoadProvider", '$locationProvider',
 function($urlRouterProvider, $stateProvider, $ocLazyLoadProvider, $locationProvider) {

    $locationProvider.hashPrefix('');
    $urlRouterProvider.otherwise('/error/404');
    $urlRouterProvider.when('', ['$state', '$match', function ($state, $match) {
        $state.go('index');
    }]);

    $ocLazyLoadProvider.config({
        events: true,
    });

    $stateProvider
        .state('error', {
            title: 'Error',
            url: '/error/:error',
            template: baseErrorTpl,
            controller: 'ErrorPageController as error'
        })
        .state('daily-consumption', {
            title: 'Content Statistics',
            url: '/daily-consumption/project/:projectId',
            template: dashboardContentStatisticsReportTpl,
            controller: 'ContentStatisticsController'
        })
        .state('sim-overview', {
            title: 'Sim Overview',
            url: '/sim-overview/project/:projectId?trainView',
            template: simOverviewSimOverviewTpl,
            controller: 'SimOverviewController as sim',
            resolve: Object.assign({}, simOverviewControllerResolve, {
                lazyLoadTrainConfig: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../sim-overview/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.simOverview'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })
        })
        .state('noc-project', {
            title: 'NOC Project',
            url: '/configuration',
            abstract: true,
            template: '<ui-view/>'
        })
        .state('noc-project.config', {
            title: 'NOC Project Config',
            url: '/project',
            template: `<project-configuration></project-configuration>`,
        })
        .state('noc-project.train-types-config', {
            title: 'NOC Train Types Config',
            url: '/train-types',
            template:  `<train-types-configuration></train-types-configuration>`
        })
        .state('trend', {
            title: 'Trend',
            url: '/trip/trend/project/:projectId',
            template: slaTrendAnalysisTrendTpl,
            controller: 'TripTrendController',
            resolve: Object.assign({}, tripTrendControllerResolve, {
                lazyLoadTrainConfig: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../sla-trend-analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.slaTrendAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            })
        })
        .state('train-schedule', {
            title: 'Train Schedule',
            url: '/trainschedule/project/:projectId',
            template: trainScheduleTrainScheduleTpl,
            controller: 'TrainScheduleController as vm'
        })
        .state('trip', {
            abstract: true,
            url: '/trip',
            template: '<ui-view/>',
            resolve: {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('trip.search', {
            title: 'Trip Search',
            url: '/search/project/:projectId?from&to&trainIds&main',
            template: analysisTripOverviewTpl,
            controller: 'TripOverviewController',
            resolve: tripOverviewControllerResolve
        })
        .state('period', {
            abstract: true,
            url: '/period',
            template: '<ui-view/>',
            resolve: {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('period.search', {
            title: 'Period Analysis',
            url: '/period-analysis/project/:projectId',
            views: {
                '': {
                    template: analysisBaseTpl,
                    controller: 'BaseAnalysisController as base'
                }
            },
            resolve: Object.assign({}, baseAnalysisControllerPeriodResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })
        })

        .state('period-analysis', {
            title: 'Period Analysis',
            abstract: true,
            url: '/period-analysis/project/:projectId/train/:trainId?startDate&endDate&filter&minimum&maximum&intervals&reverseColors&logscale&reload&live&follow&intervalTime&templateId&templateConfigName&tab&stacking&interpolate&interpolateSeconds',
            views: {
                '': {
                    template: analysisBaseTpl,
                    controller: 'BaseAnalysisController as base'
                }
            },
            resolve: Object.assign({}, baseAnalysisControllerPeriodResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })
        })
        .state('period-analysis.chart', {
            title: 'Period Analysis Chart',
            url: '/chart',
            template: analysisChartTpl,
            controller: 'ChartAnalysisController as ch'
        })
        .state('period-analysis.coverage-map', {
            title: 'Period Analysis Coverage Map',
            url: '/coverage-map',
            template: analysisCoverageMapTpl,
            controller: 'CoverageMapAnalysisController as cm'
        })
        .state('period-analysis.vu', {
            title: 'Period Analysis Vu',
            url: '/vu',
            template: analysisVuTpl,
            controller: 'VuAnalysisController as vu'
        })
        .state('trip-analysis', {
            title: 'Trip Analysis',
            url: '/trip-analysis/project/:projectId/trip/:tripId?filter&minimum&maximum&intervals&reverseColors&logscale&reload&templateId&tab&stacking&interpolate&interpolateSeconds',
            template: analysisBaseTpl,
            controller: 'BaseAnalysisController as base',
            abstract: true,
            resolve: Object.assign({}, baseAnalysisControllerTripResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })

        })
        .state('trip-analysis.chart', {
            title: 'Trip Analysis Chart',
            url: '/chart',
            template: analysisChartTpl,
            controller: 'ChartAnalysisController as ch'
        })
        .state('trip-analysis.coverage-map', {
            title: 'Trip Analysis Coverage Map',
            url: '/coverage-map',
            template: analysisCoverageMapTpl,
            controller: 'CoverageMapAnalysisController as cm'
        })
        .state('trip-analysis.vu', {
            title: 'Trip Analysis Vu',
            url: '/vu',
            template: analysisVuTpl,
            controller: 'VuAnalysisController as vu'
        })

        .state('monitoring-detail.synchronization', {
            title: 'Monitoring details Synchronization',
            url:'/synchronization',
            template: monitoringSynchronizationTpl,
            controller: 'SynchronizationMonitoringPageController as vm'
        })
        .state('monitoring-detail.event', {
                title: 'Monitoring details Train Event',
                url:'/event',
                template: monitoringEventTpl,
                controller: 'EventMonitoringPageController as vm'
        });
}]);

export default app;
